import Render from '@Views/components/frame/input-invoice-number-frame.html'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Render
@Component({})
export class InputInvoiceNumberFrame extends Vue {
	@Prop({ default: '' }) value!: string
	@Prop({ default: '' }) label!: string
	@Prop({ default: '' }) placeholder!: string
	@Prop({ default: false }) readonly!: boolean
	@Prop({ default: false }) disabled!: boolean
	@Prop({ default: false }) required!: boolean
	@Prop({ default: false }) errorTest!: boolean
	@Prop({ default: 'Format attendu : 2 chiffres pour l’année, puis 5 à 8 chiffres pour le numéro de facture (ex : 2500123).' }) errorMsg!: string
	@Prop({ default: 'invoice-number' }) id!: string

	invoiceNumber: string = this.value
	regex: string = '^[0-9]{7,10}$';

	get inputId() {
		return `input-${this.id}`
	}

	get displayError(): boolean {
		return this.errorTest && !this.isValid
	}

	get isValid(): boolean {
		return new RegExp(this.regex).test(this.invoiceNumber)
	}

	onInput() {
		this.$emit('input', this.invoiceNumber)
	}

	onBlur() {
		this.$emit('blur')
	}
}

